import { render, staticRenderFns } from "./Auditoria.vue?vue&type=template&id=08ca34b8&scoped=true"
import script from "./Auditoria.vue?vue&type=script&lang=js"
export * from "./Auditoria.vue?vue&type=script&lang=js"
import style0 from "./Auditoria.vue?vue&type=style&index=0&id=08ca34b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ca34b8",
  null
  
)

export default component.exports